module.exports = __webpack_public_path__ + "static/media/top_yellow_transition.02dcdfa0.png";